import React from "react";

const Footer = () => {
    return (
        <footer className={"footer"}>© 2023, estructura empresarial</footer>
    )
}

export default Footer;